/* eslint-disable no-nested-ternary */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import { Popover, Spin, Table } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartFlatbed } from '@fortawesome/free-solid-svg-icons';
import './style.scss';
/**
 *
 */
function MetricActiveProducts({
  data, loading, MONEY,
}) {
  const getTenantTotalLog = (record) => {
    const val = (record?.out_of_stock_count > 0 ? Math.log(record?.out_of_stock_count) : 0) + (record?.running_low_count > 0 ? Math.log(record?.running_low_count) : 0) + (record?.well_stocked_count > 0 ? Math.log(record?.well_stocked_count) : 0);
    return val;
  };
  const columns = [
    {
      title: 'Location',
      render: (text, record) => <H3Text text={record?.tenant_name?.trim()?.length > 10 ? `${record?.tenant_name.trim()?.substring(0, 10)}..` : record?.tenant_name} className="" />,
    },
    {
      title: 'Products',
      render: (text, record) => <H3Text text={MONEY(record?.item_count)?.substring(1, MONEY(record?.item_count)?.length - 3)} className="" />,
    },
    {
      title: '',
      width: '100px',
      render: (text, record) => (
        <div className="metric-inv__expiry_split__bar" style={{ height: '8px' }}>
          <Popover title={(
            <div className="metric-inv__expiry_split__bar-info">
              <H3Text text={`${record?.well_stocked_count} Products`} className="metric-inv__expiry_split__bar-info-value" />
              <H3Text text="Well Stocked" className="metric-inv__expiry_split__bar-info-text" />
            </div>
          )}
          >
            <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${(((Math.log(record?.well_stocked_count) / getTenantTotalLog(record)) || 0) * 100)}%`, backgroundColor: 'rgb(34, 197, 94)' }} />
          </Popover>
          <Popover title={(
            <div className="metric-inv__expiry_split__bar-info">
              <H3Text text={`${record?.running_low_count} Products`} className="metric-inv__expiry_split__bar-info-value" />
              <H3Text text="Running Low" className="metric-inv__expiry_split__bar-info-text" />
            </div>
          )}
          >
            <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${(((Math.log(record?.running_low_count) / getTenantTotalLog(record)) || 0) * 100)}%`, backgroundColor: 'rgb(245,210,47)' }} />
          </Popover>
          <Popover title={(
            <div className="metric-inv__expiry_split__bar-info">
              <H3Text text={`${record?.out_of_stock_count} Products`} className="metric-inv__expiry_split__bar-info-value" />
              <H3Text text="Out of Stock" className="metric-inv__expiry_split__bar-info-text" />
            </div>
          )}
          >
            <div className="metric-inv__expiry_split__bar-expired" style={{ width: `${(((Math.log(record?.out_of_stock_count) / getTenantTotalLog(record)) || 0) * 100)}%`, backgroundColor: 'rgb(255, 86, 48)' }} />
          </Popover>
        </div>
      ),
    },
  ];

  return (
    <div className="metric-inv__active-products__wrapper">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-inv__active-products">
        <div className="metric-inv__active-products-count">
          <div className="metric-inv__active-products-icon">
            <FontAwesomeIcon icon={faCartFlatbed} />
          </div>
          <div>
            <H3Text text="Active Products" className="metric-inv__active-products-title" />
            <div className="metric-inv__active-products__details">
              <H3Text text={MONEY(data?.total_available_products).substring(1, MONEY(data?.total_available_products)?.length - 3)} className="metric-inv__active-products-value" />
            </div>
          </div>
        </div>
        <div className="metric-inv__active-split-table">
          {data?.product_status_count?.length ? (
            <Table
              showHeader
              size="small"
              scroll="scroll"
              columns={columns}
              dataSource={data?.product_status_count || []}
              pagination={data?.product_status_count?.length > 2 ? {
                pageSize: 2,
              } : false}
            />
          ) : ''}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
});

MetricActiveProducts.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricActiveProducts));
